import yn from "yn";
import useUser from "~/contexts/user";
import useUsers from "~/pages/admin/hooks/useUsers";

const { VITE_CATALOG_ENABLED, VITE_SEMANTIC_CATALOG_ENABLED, VITE_CATALOG_WHITELIST_USER_ROLES } =
  import.meta.env;

export const useSemanticCatalogEnabled = (): boolean => {
  return yn(VITE_SEMANTIC_CATALOG_ENABLED, { default: false });
};

const useCatalogEnabled = (): boolean => {
  const user = useUser();
  const shouldCheckWhitelist = !!VITE_CATALOG_WHITELIST_USER_ROLES;
  const { data: userData } = useUsers({
    searchQuery: user?.email,
    activeOnly: true,
    enabled: shouldCheckWhitelist,
  });

  const catalogEnabledByRole = shouldCheckWhitelist
    ? (() => {
        const userRoles = userData?.[0]?.roles.map((role) => role.id) ?? [];
        const whitelist = String(VITE_CATALOG_WHITELIST_USER_ROLES)
          .split(",")
          .map((r) => r.trim());
        return userRoles.some((role) => whitelist.includes(role));
      })()
    : true;

  return yn(VITE_CATALOG_ENABLED, { default: false }) && catalogEnabledByRole;
};

export default useCatalogEnabled;
